export var APIAccessLevel;
(function (APIAccessLevel) {
    APIAccessLevel["ADMIN"] = "ADMIN";
    APIAccessLevel["EDITOR"] = "EDITOR";
    APIAccessLevel["COMMENTER"] = "COMMENTER";
    APIAccessLevel["EDITOR_SHARE"] = "EDITOR_SHARE";
    APIAccessLevel["OWNER"] = "OWNER";
    APIAccessLevel["VIEWER"] = "VIEWER";
})(APIAccessLevel || (APIAccessLevel = {}));
//# sourceMappingURL=APIAccessLevel.js.map